import type { ShareInvoicesRequest } from '@vy/api-definition';
import { useMutation, type UseMutationOptions } from 'react-query';
import { getPrivateApi } from '../../services/api';

export function useShareInvoices(options?: UseMutationOptions<void, unknown, ShareInvoicesRequest>) {
  const api = getPrivateApi();

  return useMutation({
    mutationFn: async (shareInvoicesRequest) => api.shareInvoices({ shareInvoicesRequest }),
    ...options,
  });
}
